import React, {Component} from 'react';
import {Button} from 'semantic-ui-react';
import {Redirect} from 'react-router';

class TravelStoriesThumb extends Component{
	constructor(props){
		super(props);
		this.state = {
			index: this.props.index,
			thumbnail: this.props.thumbnail,
			name: this.props.name,
			description: this.props.description,
			country: this.props.country,
			href: this.props.href,
			alt: this.props.name,
			data: this.props.data,
            hideText: true,
			hover: false
		};
	}
	
	redirectPage = () => {
		this.setState({redirect: true});
		window.scrollTo(0, 110)
	}

	hoverOn = () => this.setState({hover: true, hideText: false});
	hoverOff = () => this.setState({hover: false, hideText: true});
	
	render(){
		let title;
		
		title = (
				
			<div className="overlay-blue-title overlay-title-top">	
				{this.state.redirect &&
					<Redirect push to={this.props.href}/>
				}
				<div className="display-table">
					<div className="display-table-cell">					
						<p className="tour-name">{this.state.name}</p>
						
					</div>
				</div>
			</div>
		);


		return (
			<div className='thumb '>
				
				{title}
				<img
					alt=""
					src={this.state.thumbnail}
					className={this.state.hover ? 'thumb-hover' : 'thumb-hover-leave'}
				/>
				<div className="travel-stories-button">
					<Button color='orange' onClick={this.redirectPage}>&emsp; Read story &emsp;</Button>
				</div>
			</div>
		);
	}
}

export default TravelStoriesThumb;